import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import TotalSidebar from '../components/TotalSidebar/TotalSidebar'
import OrderDetailscontainer from '../components/OrderDetailscontainer/OrderDetailscontainer'
import Footer from '../components/Footer/Footer'
import ProductOrderBox from '../components/ProductOrderBox/ProductOrderBox'
import PageHeader from '../components/PageHeader/PageHeader'
import { Col, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { useParams } from 'react-router-dom'

function OrderDetails() {
  const [order, setOrder] = useState([])
  const userinfo = useSelector((state) => state);
  const [show, setShow] = useState(false);
const {id}=useParams()

  useEffect(() => {
    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/smile/api/orders`,

          {
            headers: {
              Authorization: `Bearer ${userinfo.auth.access_token}`
            }
          })

        .then(async (res) => {
          const filteredArray = res.data.data.filter(item => item.id==id);
          setOrder(filteredArray[0]);

          setShow(true)

        })
        .catch((error) => {
          setShow(true)



        });
    }
    getAllApis()
  }, [])
  
  return (
    <>
    <NavbarContainer/>

    <Container  className='py-5'>
      <Row>

        <Col md={8}>
        <OrderDetailscontainer
                order={order&&order}

        />
        </Col>
        <Col md={4}>
        <ProductOrderBox
                        items={order&&order&&order.details}
                        state={"order"}
                        order={order&&order}


        />


        </Col>
      </Row>
    </Container>
    <Footer/>
    </>   )
}

export default OrderDetails